import { GlobalFooter } from "@/patterns/global-footer/src/global-footer";
import JSWFeaturesPageReportsAndInsights from "@/templates/software/jira/features/jira-software-features-page/src/sections/reports-and-insights";
import Timeline from "@/templates/software/jira/features/jira-software-features-page/src/sections/timeline";
import JiraSoftwareNavV2 from "@/templates/software/jira/sections/nav-bar/software-jira-navbar";

import { JSWFeaturesPageBanner } from "./sections/banner";
import CTASection from "./sections/cta";
import DevOpsSection from "./sections/dev-ops";
import DragAndDropSection from "./sections/drag-and-drop";
import FeaturesSection from "./sections/features";
import HeroSectionControl from "./sections/hero";
import ProjectFlexibilitySection from "./sections/project-flexibility";
import ScrumKanbanBoardSection from "./sections/scrum-kanban-board";
import { SecurityScaleSection } from "./sections/security-scale";
import SocialProof from "./sections/social-proof";

export const JiraSoftwareFeaturesPageTemplate = () => {
    return (
        <div>
            <JiraSoftwareNavV2 />
            <main id="content">
                {/* Features Page content */}
                <JSWFeaturesPageBanner />
                <HeroSectionControl />
                <Timeline />
                <ScrumKanbanBoardSection />
                <JSWFeaturesPageReportsAndInsights />
                <ProjectFlexibilitySection />
                <DragAndDropSection />
                <FeaturesSection />
                <DevOpsSection />
                <SecurityScaleSection />
                <SocialProof />
                <CTASection />
            </main>
            <GlobalFooter />
        </div>
    );
};
